import React from "react";
import styled, { css } from "styled-components";
import { useHistory } from "react-router-dom";

import { Text } from "src/library/components/Text";
import { ActionButton } from "src/library/components/Button";
import { ITerminology } from "src/library/utils";
import { IProductCategory } from "src/core/products/api/products.api";

export interface CategoryChildRowProps extends Omit<IProductCategory, "sortOrder" | "parentId"> {
  terminology: ITerminology;
  onDeleteCategory?: (category: Pick<IProductCategory, "name" | "id">) => void;
  hideActions?: boolean;
}

/**
 * Child category view for both editable and un-editable category children
 *
 * @returns a child category row react element
 */
export const CategoryChildRow: React.ReactFCWithChildren<CategoryChildRowProps> = ({
  id,
  name,
  terminology,
  hideActions = false,
  onDeleteCategory = () => {}
}) => {
  const history = useHistory();

  return (
    <CategoryChildRowWrapper
      style={!hideActions ? {
        margin: "0 0 0 30px",
        width: "calc(100% - 30px)"
      } : {}}
    >
      <Text>
        {name}
      </Text>

      {!hideActions && (
        <ActionButton
          title="Actions"
          items={[
            {
              title: `View/Edit ${terminology.category.singular.text}`,
              action: () => {
                history.push(`/admin/products/categories/${id}`);
              }
            },
            {
              title: `Delete ${terminology.category.singular.text}`,
              action: () => {
                onDeleteCategory({
                  name,
                  id
                });
              }
            }
          ]}
        />
      )}
    </CategoryChildRowWrapper>
  );
};

const CategoryChildRowWrapper = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.white};
    padding: ${theme.spacing.padding.sm} ${theme.spacing.padding.md}; 
    border-bottom: ${theme.colors.lightGrey} 1px solid;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 60px;
    padding-right: 30px;
  `}
`;
